import * as React from "react";

import { useDispatch, useSelector } from "react-redux";

import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import { dataExplorerActions } from "../../store";

export default function GenericCategorySelection({
  categoryId,
  categoryLabel,
  options,
}) {
  const dispatch = useDispatch();
  const selectedEntity = useSelector(
    (state) => state.dataExplorer.selectedEntity
  );
  const filters = useSelector(
    (state) => state.dataExplorer.filters[selectedEntity]
  );
  const selectedFilterOptions = filters[categoryId] || [];

  const handleCheckboxChange = (e) => {
    const newSelectedIds = selectedFilterOptions.includes(e.target.value)
      ? selectedFilterOptions.filter((val) => val !== e.target.value)
      : [...selectedFilterOptions, e.target.value];

    // set dataset filter
    dispatch(
      dataExplorerActions.setFilter({
        id: categoryId,
        value: newSelectedIds,
        selectedEntity
      })
    );
  };

  const handleAutocompleteChange = (event, newValue) => {
    dispatch(
      dataExplorerActions.setFilter({
        id: categoryId,
        value: newValue,
        selectedEntity,
      })
    );
  };

  return options.length > 6 ? (
    <Autocomplete
      disableCloseOnSelect
      fullWidth
      limitTags={3}
      multiple
      options={options.filter(
        (option) => !selectedFilterOptions.includes(option)
      )}
      value={selectedFilterOptions}
      onChange={handleAutocompleteChange}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={categoryLabel || "Options"}
        />
      )}
    />
  ) : (
    <FormControl>
      {options
        .sort((a, b) => a.localeCompare(b))
        .map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                color="secondary"
                checked={selectedFilterOptions.includes(option)}
                onChange={handleCheckboxChange}
                value={option}
              />
            }
            label={option}
          />
        ))}
    </FormControl>
  );
}
